<template>
  <section class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
    </keep-alive>
    <transition name="fade" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive" :key="$route.path"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue